import { Page } from '@/core/architecture'

import { ConsolePreSaleCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsolePreSaleCreate Page
 * Implemented as a practical sample.
 */
export const ConsolePreSaleCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsolePreSaleCreateTemplate state={state} {...actions} />
}
